<template>
    <span
        v-click-outside="hideDropdown"
        class="dropdown"
        @click.prevent="toggleDropdown()"
    >
        <a
            href="#"
            class="user__email"
            >{{ user.email }}</a
        >
        <span class="dropdown__icon icon-chevron-right"></span>
        <ul
            v-if="isDropdownOpen"
            class="dropdown__drop"
        >
            <li>
                <router-link
                    tag="a"
                    :to="changePasswordRoute"
                    >Change Password</router-link
                >
            </li>
            <li>
                <a
                    href="#"
                    @click.prevent="logout()"
                    >Logout</a
                >
            </li>
        </ul>
    </span>
</template>

<script>
import needsOrganizationSlug from '@/mixins/needsOrganizationSlug'

export default {
    name: 'AccountDropdown',

    mixins: [needsOrganizationSlug],

    props: ['user'],

    data() {
        return {
            isDropdownOpen: false,
        }
    },

    computed: {
        changePasswordRoute() {
            return this.organizationSlug ? `/${this.organizationSlug}/change-password` : '/change-password'
        },
    },

    methods: {
        toggleDropdown() {
            this.isDropdownOpen = !this.isDropdownOpen
        },

        hideDropdown() {
            this.isDropdownOpen = false
        },

        logout() {
            this.$store
                .dispatch('logout')
                .then((redirectUrl) => {
                    const url = new URL(redirectUrl, window.location.origin)
                    window.location.href = url.toString()
                })
                .catch((_) => {
                    //
                })
        },
    },
}
</script>
